import { render, staticRenderFns } from "./SsoRegistrationPane.vue?vue&type=template&id=52b70fb8&scoped=true"
import script from "./SsoRegistrationPane.vue?vue&type=script&lang=js"
export * from "./SsoRegistrationPane.vue?vue&type=script&lang=js"
import style0 from "./SsoRegistrationPane.vue?vue&type=style&index=0&id=52b70fb8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b70fb8",
  null
  
)

export default component.exports